<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('affiliateRelationManage.confirmDeleteRelation') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAffiliateRelation">{{ $t('common.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAffiliateRelation } from '@/api/affiliate/affiliateRelationApi'

export default {
  name: 'DeleteAffiliateRelation',
  data() {
    return {
      dialogVisible: false,
      deleteAffiliateRelationInfo: {
        arId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteAffiliateRelationInfo.arId = row.arId
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteAffiliateRelationInfo = {
        arId: ''
      }
    },
    deleteAffiliateRelation() {
      let shopId = this.getShopId();
      this.deleteAffiliateRelationInfo.shopId = shopId
      deleteAffiliateRelation(this.deleteAffiliateRelationInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('common.submitSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(error => {
          this.$message.error(this.$t('common.deleteFailed'))
          console.error('请求失败处理:', error)
        })
    }
  }
}
</script>